<!-- pc端的最外层容器，用于固定页面布局 -->
<template>
  <el-container>
    <el-header>
      <sys-header />
    </el-header>
    <el-container class="center">
      <el-aside width="">
        <sys-asider />
      </el-aside>

      <el-main>
        <!-- <transition name="el-zoom-in-top"> -->
          <router-view />
        <!-- </transition> -->
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
import SysHeader from "content/header";
import SysAsider from "content/asider";

export default {
  components: {
    SysHeader,
    SysAsider,
  },
};
</script>
<style lang="less" scoped>
.el-container.is-vertical {
  height: 100%;
  .el-header {
    background: #fff;
    box-shadow: 0 3px 12px rgba(82, 82, 82, 0.199);
    position: relative;
    z-index: 1;
  }
  .center {
    height: calc(100% - 60px);
  }
}

.el-card__body,
.el-main {
  padding: 1.5rem 1rem;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>